import { IRoute } from "../app";
import RunMode from "../platform/pages/run-mode/run-mode";
import CreatePdf from "./pages/create-pdf/create-pdf";
import DatasetDetails from "./pages/dataset-details/dataset-details";
import DatasetList from "./pages/datasets/dataset-list";
import AnalyticsHome from "./pages/home/analytics-home";
import ModelConfigurationEdit from "./pages/model-configuration-edit/model-configuration-edit";
import ModelConfigurationNew from "./pages/model-configuration-new/model-configuration-new";
import ReportDetails from "./pages/report-details/report-details";
import ReportList from "./pages/report-list/report-list";
import ReportLogs from "./pages/report_logs/report_logs";
import RunStatus from "./pages/run-status/run-status";
import TenantTemplateList from "./pages/tenant-templates/tenant-template-list";
import TransactionMonitoringSystemConfig from "./pages/transaction-monitoring-system-config/transaction-monitoring-system-config";
import TMSConfigNewEdit from "./pages/transaction-monitoring-system-config-new/transaction-monitoring-system-config-new-edit";
import DatasetEdit from "./pages/dataset/dataset-edit";

const AnalyticsRoutes = (hasTenantAdminRole: boolean, hasWriteRole: boolean, hasReadRole: boolean) => {
  const routes: IRoute[] = [
    {
      route: {path: "/analytics", element: <AnalyticsHome />},
      allowed: hasTenantAdminRole || hasWriteRole || hasReadRole
    },
    {
      route: {path: "/analytics/datasets", element: <DatasetList />},
      allowed: hasTenantAdminRole || hasWriteRole || hasReadRole
    },
    {
      route: {path: "/analytics/datasets-details/:id", element: <DatasetDetails />},
      allowed: hasTenantAdminRole || hasWriteRole || hasReadRole
    },
    {
      route: {path: "/analytics/datasets-edit/:id", element: <DatasetEdit />},
      allowed: hasTenantAdminRole || hasWriteRole || hasReadRole
    },
    {
      route: {path: "/run-mode-configuration", element: <RunMode />},
      allowed: hasTenantAdminRole
    },
    {
      route: {path: "/analytics/transaction-monitoring-system-config", element: <TransactionMonitoringSystemConfig />},
      allowed: hasTenantAdminRole
    },
    {
      route: {path: "/analytics/transaction-monitoring-system-config/new", element: <TMSConfigNewEdit />},
      allowed: hasTenantAdminRole
    },
    {
      route: {path: "/analytics/transaction-monitoring-system-config/:id", element: <TMSConfigNewEdit />},
      allowed: hasTenantAdminRole
    },
    {
      route: {path: "/analytics/admin/templates", element: <TenantTemplateList />},
      allowed: hasTenantAdminRole
    },
    {
      route: {path: "/analytics/datasets-details/:id/modelconfig/new", element: <ModelConfigurationNew />},
      allowed: hasWriteRole
    },
    {
      route: {path: "/analytics/datasets/new", element: <DatasetEdit />},
      allowed: hasWriteRole
    },
    {
      route: { path: "/analytics/run-status", element: <RunStatus />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/analytics/reports/:id", element: <ReportDetails />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/analytics/reports/:id/create-pdf", element: <CreatePdf />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/analytics/reports/:id/logs", element: <ReportLogs />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/analytics/modelconfig/:id/reports", element: <ReportList />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/analytics/datasets/:id/reports", element: <ReportList />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/analytics/modelconfig/:id", element: <ModelConfigurationEdit />},
      allowed: hasWriteRole || hasReadRole
    }
  ];
  return routes.filter((route) => route.allowed).map((route) => route.route);
};

export default AnalyticsRoutes;
